import React from 'react';
import Modal from '@material-ui/core/Modal';
import styles from '../../../Pages/OptionsBoard/OptionsBoardStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import axios from 'axios';
import { Button } from '@material-ui/core';
import { BaseURL } from '../../../constants';

const WatchListDeleteFavouriteTicker = ({
  favLoading,
  userData,
  data,
  isMobile,
  showModal,
  setShowModal,
  handleClickSnakFavTicker,
  setFavLoading,
  setwatchlistFavDeleteModal,
}) => {
  const DeleteFav = async () => {
    setFavLoading(true);
    let snakMessage;
    let snaktype;
    try {
      await axios.post(`${BaseURL}/api/DeleteFav?userId=${userData.sub}`, data);
      snakMessage = 'Deleted From Watchlist';
      snaktype = 'success';
      handleClickSnakFavTicker(snakMessage, snaktype);
    } catch (error) {
      snakMessage = 'Something went Wrong';
      snaktype = 'error';

      handleClickSnakFavTicker(snakMessage, snaktype);
    }
  };
  return (
    <div style={isMobile ? { width: '220px' } : { width: '400px' }}>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <div
          style={
            isMobile
              ? styles.ToolTipboardModalContentWatchListModalMobile
              : styles.ToolTipboardModalContentWatchListModal
          }
        >
          <div
            onClick={() => setShowModal(false)}
            style={
              !isMobile
                ? { ...styles.modalCloseButton, marginTop: '2px' }
                : { ...styles.modalCloseButtonMobile, marginTop: '2px' }
            }
          >
            X
          </div>

          <div style={{ ...styles.ModalTable, width: '50%' }}>
            <div style={styles.AreYouSureText}>
              <div>Are you sure that you want to Delete?</div>
            </div>
            <Table style={{ tableLayout: isMobile ? 'fixed' : '' }}>
              <TableBody>
                {data.map((row, index) => {
                  return (
                    <TableRow
                      style={{ ...styles.tableRow, height: '5px' }}
                      key={index}
                    >
                      <TableCell
                        style={{
                          ...styles.modalTableRow,
                          padding: '0 5px',
                          width: '20px',
                          backgroundColor: '#FFFCD1',
                        }}
                        align="center"
                      >
                        {row.name}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>

            <div style={styles.AreYouSureText}>
              <Button
                id="btnGO"
                variant="contained"
                disabled={favLoading}
                style={{
                  ...styles.goButton,
                  minWidth: '22px',
                  maxWidth: '22px',
                  marginTop: '8px',
                  height: '26px',
                  backgroundColor: 'darkgrey',
                  color: 'black',
                  border: '1px solid',
                  fontSize: '12px',
                }}
                onClick={() => {
                  if (!favLoading) {
                    DeleteFav();
                  }
                }}
              >
                Go
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WatchListDeleteFavouriteTicker;



// WEBPACK FOOTER //
// ./src/components/Modals/WatchListDeleteFavouriteTicker/index.js